import { ServiceCenterDetail } from 'feature/serviceCenters/view'
import { MainLayout } from 'layouts'

export function ServiceCenterDetailPage() {
  return (
    <MainLayout>
      <div className='container'>
        <ServiceCenterDetail />
      </div>
    </MainLayout>
  )
}
